import { Body, Controller, Post, UploadedFiles, UseInterceptors } from "@nestjs/common";
import { ApiBody, ApiConsumes, ApiOperation, ApiResponse, ApiTags } from "@nestjs/swagger";
import { NeedleModelService } from "./needle-model-service";
import { NeedleModelCreateRequest, NeedleModelModel, NeedleModelResponse } from "@needle-management/shared-models";
import { CommonResponseModel } from "@needle-management/shared-models";




@ApiTags('Needle Model')
@Controller('needle-model')
export class NeedleModelController {
  constructor(
    private service: NeedleModelService,
  ) { }

  @Post('createNeedleModel')
  @ApiBody({ type: NeedleModelCreateRequest })
  async createNeedleModel(@Body() req: NeedleModelCreateRequest): Promise<NeedleModelResponse> {
    try {
      return await this.service.createNeedleModel(req);
    } catch (error) {
      throw error
    }
  }

   @Post('updateNeedleModel')
  @ApiBody({ type: NeedleModelModel })
  async updateNeedleModel(@Body() req: NeedleModelModel): Promise<NeedleModelResponse> {
    try {
      return await this.service.updateNeedleModel(req);
    } catch (error) {
      throw error
    }
  }

  @Post('deleteNeedleModel')
  @ApiBody({ type: NeedleModelModel })
  async deleteNeedleModel(@Body() req: NeedleModelModel): Promise<NeedleModelResponse> {
    try {
      return await this.service.deleteNeedleModel(req);
    } catch (error) {
      throw error
    }
  }

  @Post('getAllNeedleModels')
  @ApiBody({ })
  async getAllNeedleModels(): Promise<NeedleModelResponse> {
    try {
      return await this.service.getAllNeedleModels();
    } catch (error) {
      throw error
    }
  }

  @Post('/getActiveNeedleModel')
  async getActiveNeedleModel(): Promise<CommonResponseModel> {
      return await this.service.getActiveNeedleModel();
  }

  @Post('activateDeactivateNeedleModel')
  @ApiBody({ type: NeedleModelModel })
  async activateDeactivateNeedleModel(@Body() req: NeedleModelModel): Promise<NeedleModelResponse> {
    try {
      return await this.service.activateDeactivateNeedleModel(req);
    } catch (error) {
      throw error
    }
  }

  @Post('getActiveModels')
  async getActiveModels(): Promise<CommonResponseModel> {
    try {
      return await this.service.getActiveModels();
    } catch (error) {
      throw error
    }
  }
    
}